import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const entryPointPremiumUpgradeModal = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "entryPoint-premium-upgrade-modal" */ './ui/index').then(
			(module) => module.PremiumUpgradeModalEntryPoint,
		),
	),
	getPreloadProps: () => ({}),
});
